import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { totalsTicketsAndWinByUserId } from "../../utilities/services/tickets";

// Thunk for the API call
export const fetchTotalsTicketsAndWinByUserId = createAsyncThunk(
  "userTicketsAndWins/fetchTotals",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await totalsTicketsAndWinByUserId(userId);
      return response.data; // Returning the response data
    } catch (error) {
      // Handling errors with rejectWithValue
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Initial state
const initialState = {
  totalTicketsAndWin: [],
  loading: false,
  error: null,
};

// Slice for handling state
const userTicketsAndWinsSlice = createSlice({
  name: "userTicketsAndWins",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalsTicketsAndWinByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTotalsTicketsAndWinByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.totalTicketsAndWin = action.payload;
      })
      .addCase(fetchTotalsTicketsAndWinByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the reducer to include in the store
export default userTicketsAndWinsSlice.reducer;
